import { render, staticRenderFns } from "./modifygreet.vue?vue&type=template&id=c54e027e"
import script from "./modifygreet.vue?vue&type=script&lang=js"
export * from "./modifygreet.vue?vue&type=script&lang=js"
import style0 from "./modifygreet.vue?vue&type=style&index=0&id=c54e027e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports